import { View } from "@aws-amplify/ui-react"
import styled from "styled-components" 

export const APadded = styled(View)`
    width:100%;
    padding:2rem;
    @media (max-width: 500px) {
        padding:10px !important;
    }
`

export const APaddedCenter = styled(View)`
    width:100%;
    padding:2rem;
    @media (max-width: 500px) {
        padding:10px !important;
    }
    text-align:center;
`

export const NextBackButtonHolder = styled(View)`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    border-top:1px solid #CCC;
    padding-top:15px;
`

